import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar.js";

export function Layout() {
  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "var(--surface-page)" }}>
      <Sidebar />
      <main
        style={{
          flex: 1,
          padding: "24px 32px 48px",
          maxWidth: "calc(100vw - 240px)",
          minWidth: 0,
          overflow: "auto",
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
